export default function cn(...c) {
  return c.filter(Boolean).join(" ");
}